module.exports = __webpack_public_path__ + "static/media/testimonial-claudia-nl.7e4ce178.webp";